module.exports = __webpack_public_path__ + "img/friends.5560b296.png";